import React, { useRef, useEffect, useCallback } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Swiper as SwiperType } from 'swiper';
import 'swiper/css';

const features = [
    { icon: '/img/diet.png', title: 'Удобный трекинг', description: 'Отмечайте свои успехи.' },
    { icon: '/img/brain.png', title: 'Современные технологии', description: 'ИИ анализирует ваши риски.' },
    { icon: '/img/healthcare.svg', title: 'Комплексный подход', description: 'Заботимся обо всех аспектах.' },
    { icon: '/img/letter.svg', title: 'Рекомендации', description: 'Система подстраивается под вас.' },
    { icon: '/img/dashboard.svg', title: 'Аналитика', description: 'Каждый месяц — новые выводы.' },
    { icon: '/img/customer-support.svg', title: 'Выгода', description: 'Скидки от партнёров.' },
];

const FeaturesSlider: React.FC = () => {
    const swiperRef = useRef<SwiperType | null>(null);
    const prevBtnRef = useRef<HTMLDivElement | null>(null);
    const nextBtnRef = useRef<HTMLDivElement | null>(null);

    const updateNavState = useCallback(() => {
        const swiper = swiperRef.current;
        if (!swiper) return;

        if (prevBtnRef.current) {
            prevBtnRef.current.classList.toggle('slider-nav__button_disabled', swiper.isBeginning);
        }

        if (nextBtnRef.current) {
            nextBtnRef.current.classList.toggle('slider-nav__button_disabled', swiper.isEnd);
        }
    }, []);

    useEffect(() => {
        const swiper = swiperRef.current;
        if (!swiper) return;

        updateNavState();

        swiper.on('slideChange', updateNavState);
        swiper.on('transitionEnd', updateNavState);
        swiper.on('reachBeginning', updateNavState);
        swiper.on('reachEnd', updateNavState);

        return () => {
            swiper.off('slideChange', updateNavState);
            swiper.off('transitionEnd', updateNavState);
            swiper.off('reachBeginning', updateNavState);
            swiper.off('reachEnd', updateNavState);
        };
    }, [updateNavState]);

    return (
        <div className="features__cards_mobile features-cards">
            <div className="slider features-cards__slider">
                <Swiper
                    onSwiper={(swiper: SwiperType) => {
                        swiperRef.current = swiper;
                        setTimeout(updateNavState, 0);
                    }}
                    spaceBetween={16}
                    centeredSlides={true}
                    slidesPerView={1.1}
                    breakpoints={{
                        768: {
                            slidesPerView: 3,
                            centeredSlides: false,
                            enabled: false,
                        },
                    }}
                >
                    {features.map((item, index) => (
                        <SwiperSlide key={index}>
                            <div className="feature-card">
                                <img className="svg-icon feature-card__icon" src={item.icon} alt={item.title} />
                                <h5 className="title feature-card__title">{item.title}</h5>
                                <p className="feature-card__description">{item.description}</p>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>

                <div className="slider__nav slider-nav">
                    <div
                        ref={prevBtnRef}
                        className="slider-nav__button slider-nav__button_prev"
                        onClick={() => {
                            swiperRef.current?.slidePrev();
                            setTimeout(updateNavState, 0);
                        }}
                    >
                        <svg className="svg-icon" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <use href="/img/sprite-icons.svg#arrow-left" />
                        </svg>
                    </div>
                    <div className="slider-nav__separator"></div>
                    <div
                        ref={nextBtnRef}
                        className="slider-nav__button slider-nav__button_next"
                        onClick={() => {
                            swiperRef.current?.slideNext();
                            setTimeout(updateNavState, 0);
                        }}
                    >
                        <svg className="svg-icon" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <use href="/img/sprite-icons.svg#arrow-right" />
                        </svg>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FeaturesSlider;
